export default __webpack_public_path__ + "static/media/auctane-logo-white.99a9fd56.svg";